import { useGetTodosQuery } from "../../features/todoApi/todoApiSlice";

const numberOfTodos = (no_of_todos) => {
  switch (no_of_todos) {
    case 0:
      return "No task";
    case 1:
      return "1 task";
    default:
      return `${no_of_todos} tasks`;
  }
};

export default function CompleteTodoFooter() {
  const { data: todos } = useGetTodosQuery({ complete: true });
  return (
    <div className="mt-4 flex justify-between text-xs text-gray-500">
      <p>{numberOfTodos(todos?.length)} completed</p>
    </div>
  );
}
